<template>
  <div
    class="info-block clickable"
    ref="quick-filter-button"
    :class="{'active': isActive}"
  >
    <div
      class="info-block--info-item"
      @click="emitFilter"
    >
      <span class="Fuell-Text ellipsis">
        {{filterName}}
      </span>
    </div>
    <template v-if="isActive">
      <div class="Fuell-Dropdown--button Fuell-Dropdown--button-dots-small active clickable" @click="emitEdit">
        <img :src="require('@/assets/img/icons/icon-dots.svg')" alt="" class="dots">
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'QuickFilterButton',

  props: {
    quickFilter: {
      type: Object,
      required: true
    },
    isActive: {
      type: Boolean
    }

  },
  computed: {
    filterName () {
      return this.quickFilter?.name || ''
    }

  },
  methods: {
    emitFilter () {
      this.$root.$emit('resetReviewBar')
      this.$emit('setFilteredView', this.quickFilter)
    },
    emitEdit () {
      this.$emit('editFilteredView', this.quickFilter)
    }
  }
}
</script>

<style lang="scss" scoped>
.Fuell-Text {
  font-weight: 400;
}
.Fuell-Text.red {
  color: var(--semantic-negative-main);
}
.info-block {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 8px;
  border-radius: 16px;
  gap: 4px;
  background-color: var(--grey-action-3-active);
  margin-right: 5px;
  max-height: 24px;
  max-width: 235px;

}
.info-block.active {
  background-color: var(--semantic-brand-tint);
  & > .info-block--info-item {
    > .Fuell-Text,
    .info-item--count {
      color: var(--semantic-brand-main);
      font-weight: 400;
      width: 100%;
    }
    svg {
      filter: invert(38%) sepia(62%) saturate(3783%) hue-rotate(186deg)
        brightness(100%) contrast(103%);
    }
  }
}
.info-block--info-item {
  width: 100%;
  max-width: 200px;
}
.info-block--info-item .Fuell-Text {
  font-size: 13px;
  line-height: 24px;
  max-width: 200px;
  width: 100%;
  display: block;
}
.info-item--count {
  font-size: 13px;
  font-weight: 500;
  line-height: 23px;
  color: var(--text-body);
}

.info-item--blue-text {
  margin-left: 24px;
  color: var(--blue-action-1-active);
}

.Fuell-Text {
  text-align: center;
}
</style>
<style lang="scss" scoped>
.dropdown-container {
  width: 139px;
  padding: 5px 0px;
}
.list-item {
  border-bottom: 1px solid var(--fill-divider);
  text-align: left;
  padding: 5px 12px;
}
.list-item:last-of-type {
  border: none;
}

.Fuell-Dropdown--button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  padding: 1px 6px;
  border-radius: 4px;
  &:hover {
    background-color: var(--grey-action-3-hover);
  }
  .dots {
    width: 3px;
    height: 12px;
  }
}

.Fuell-Dropdown--button-dots-small {
  display: flex;
  height: 16px;
  width: 16px;
  border-radius: 2px;
  &.active {
    & > .dots {
      filter: invert(45%) sepia(63%) saturate(5644%) hue-rotate(187deg)
        brightness(100%) contrast(104%);
    }
    &:hover {
      filter: unset;
      background-color: unset;
    }
  }
}

</style>
